import tw from 'tailwind-styled-components';

export const PageContainer = tw.section`px-8 py-8 mb-32`
export const PageHeader = tw.section`bg-gray-lighter`;
export const PageSubHeader = tw.h2`text-primary text-3xl font-normal`;
export const SectionContainer = tw.section`max-w-screen-xl w-screen-xl py-10 mx-auto`;
export const SectionHeader = tw.div`text-primary-light text-3xl mb-2`;
export const SectionSubHeader = tw.h3`text-xl font-bold text-primary-darker`
export const SectionSubTitle = tw.h4`font-bold text-primary-darker leading-tight my-2`;
export const FormSectionContainer = tw.section`mb-8 grid grid-cols-12`;
export const FormSectionHeaderContainer = tw.div`col-span-12`;
export const FormSectionHeader = tw.div`text-2xl mb-2 `;
export const FormSectionSubHeader = tw.div`text-lg mb-2`;
export const FormFieldContainer = tw.div`col-span-8`;
export const FormFieldBody = tw.div`grid grid-cols-12 gap-x-4`;
export const FormField = tw.div`col-span-6`;
export const PublicSans = tw.div`font-sans`;
export const ResourceContainer = tw.div`col-span-4 rounded-md overflow-hidden mx-4 flex flex-col h-full`;
export const ResourceImageContainer = tw.div`flex h-[140px] overflow-hidden`;
export const ResourceImage = tw.img`w-full object-cover`;
export const ResourceContent = tw.div`flex flex-col flex-grow py-4 border-2 border-gray-lighter border-t-0 [&>div]:px-6`;
export const ResourceContentHeader = tw.div`font-bold text-xl`;
export const NavLinkStyled = tw.div`${props => props.active === "true" ? 'border-0 border-b-4 border-black border-solid border-primary-light' : null} pb-4  mr-8 text-[14px] [&>a]:no-underline`;
